module.exports = __webpack_public_path__ + "img/1.f6476a13.jpg";